<template>
  <v-sheet class="mx-auto" elevation="8" max-width="1200">
    <div>
      <v-sheet class="d-flex">
        <v-card @click="prev" class="d-flex align-center">
          <span class="group pa-2" align="center" justify="center">
            <v-icon align="center" justify="center">chevron_left</v-icon>
          </span>
        </v-card>
        <v-card class="d-flex overflow-x-auto" max-width="1200">
          <v-sheet
            v-for="(n, index) in items"
            :key="n.validtime"
            class="ma-0 pa-0"
            @click="toggle(index)"
            ref="sheets"
          >
            <v-card
              class="ma-2"
              max-width="175"
              :color="isActive(index) ? undefined : 'grey lighten-1'"
              :outlined="isActive(index)"
              style="cursor: pointer"
            >
              <v-list-item three-line class="py-1">
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="headline ma-0 pa-0">
                    {{ hourAndMinutes(n.validtime) }}
                    <v-list-item-avatar tile size="25">
                      <v-img :src="getWeatherImage(n.interval)"></v-img>
                    </v-list-item-avatar>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="text-caption">Осадки: {{ n.interval }}</div>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <div class="text-caption">{{ n.validtime }}</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-sheet>
        </v-card>
        <v-card @click="next" class="d-flex align-center">
          <span class="group pa-2">
            <v-icon>chevron_right</v-icon>
          </span>
        </v-card>
      </v-sheet>
    </div>
  </v-sheet>
</template>

<script>
import moment from "moment";
import * as easings from "vuetify/es5/services/goto/easing-patterns";
import { NOWCASTING_INTERVALS } from "../../../constants";

export default {
  name: "ValidTimesSlider",
  props: {
    /**
     * validtimes
     */
    items: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /**
     * selected validtime
     */
    value: Number
  },
  data: function() {
    return {
      weather: [
        {
          from: 0,
          to: 10,
          img: "Clear.svg"
        },
        {
          from: 10,
          to: 20,
          img: "Clouds.svg"
        },
        {
          from: 20,
          to: 30,
          img: "Drizzle.svg"
        },
        {
          from: 30,
          to: 40,
          img: "Rain.svg"
        },
        {
          from: 40,
          to: 50,
          img: "Snow.svg"
        }
      ],
      clearImage: require("@/assets/weather/Clear.svg"),
      cloudsImage: require("@/assets/weather/Clouds.svg"),
      rainImage: require("@/assets/weather/Rain.svg"),
      thunderstormImage: require("@/assets/weather/Thunderstorm.svg"),
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      intervals: NOWCASTING_INTERVALS
    };
  },
  methods: {
    toggle(index) {
      this.$emit("input", index);
    },
    next() {
      if (this.value === this.items.length - 1) return;
      this.$emit("input", this.value + 1);
      this.$refs.sheets[this.value + 1].$el.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    prev() {
      if (this.value === 0) return;
      this.$emit("input", this.value - 1);
      this.$refs.sheets[this.value - 1].$el.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    isActive(index) {
      return index === this.value;
    },
    getWeatherImage(interval) {
      const intervalSettings = this.intervals.find(
        x => interval[1] >= x.from && interval[1] <= x.to
      );

      return intervalSettings.img;
    },
    changeSlide(value) {
      this.$emit("input", value);
    },
    hourAndMinutes(value) {
      return moment(value).format("HH:mm");
    }
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    }
  }
};
</script>